/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FlightPaymentOperationApprovalRequest
 */
export interface FlightPaymentOperationApprovalRequest {
    /**
     * 
     * @type {string}
     * @memberof FlightPaymentOperationApprovalRequest
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof FlightPaymentOperationApprovalRequest
     */
    bookingId: string;
    /**
     * 
     * @type {string}
     * @memberof FlightPaymentOperationApprovalRequest
     */
    paymentOperationId: string;
    /**
     * 
     * @type {string}
     * @memberof FlightPaymentOperationApprovalRequest
     */
    approvalRequestId: string;
    /**
     * 
     * @type {string}
     * @memberof FlightPaymentOperationApprovalRequest
     */
    expectedEvidenceDigest: string;
    /**
     * 
     * @type {string}
     * @memberof FlightPaymentOperationApprovalRequest
     */
    approverUserId: string;
    /**
     * 
     * @type {string}
     * @memberof FlightPaymentOperationApprovalRequest
     */
    approverEmail: string;
}

/**
 * Check if a given object implements the FlightPaymentOperationApprovalRequest interface.
 */
export function instanceOfFlightPaymentOperationApprovalRequest(value: object): value is FlightPaymentOperationApprovalRequest {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('bookingId' in value) || value['bookingId'] === undefined) return false;
    if (!('paymentOperationId' in value) || value['paymentOperationId'] === undefined) return false;
    if (!('approvalRequestId' in value) || value['approvalRequestId'] === undefined) return false;
    if (!('expectedEvidenceDigest' in value) || value['expectedEvidenceDigest'] === undefined) return false;
    if (!('approverUserId' in value) || value['approverUserId'] === undefined) return false;
    if (!('approverEmail' in value) || value['approverEmail'] === undefined) return false;
    return true;
}

export function FlightPaymentOperationApprovalRequestFromJSON(json: any): FlightPaymentOperationApprovalRequest {
    return FlightPaymentOperationApprovalRequestFromJSONTyped(json, false);
}

export function FlightPaymentOperationApprovalRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlightPaymentOperationApprovalRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['user_id'],
        'bookingId': json['booking_id'],
        'paymentOperationId': json['payment_operation_id'],
        'approvalRequestId': json['approval_request_id'],
        'expectedEvidenceDigest': json['expected_evidence_digest'],
        'approverUserId': json['approver_user_id'],
        'approverEmail': json['approver_email'],
    };
}

export function FlightPaymentOperationApprovalRequestToJSON(json: any): FlightPaymentOperationApprovalRequest {
    return FlightPaymentOperationApprovalRequestToJSONTyped(json, false);
}

export function FlightPaymentOperationApprovalRequestToJSONTyped(value?: FlightPaymentOperationApprovalRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_id': value['userId'],
        'booking_id': value['bookingId'],
        'payment_operation_id': value['paymentOperationId'],
        'approval_request_id': value['approvalRequestId'],
        'expected_evidence_digest': value['expectedEvidenceDigest'],
        'approver_user_id': value['approverUserId'],
        'approver_email': value['approverEmail'],
    };
}

